// extracted by mini-css-extract-plugin
export default {"filterWrapper":"filter_filterWrapper__iaWMH","winnerFilterW":"filter_winnerFilterW__AaRG3"};